import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText } from "lucide-react";
import { KorrekturStatusTable } from "./korrekturStatusTable.component";
import { BulkAssignmentDialogProvider } from "../contexts/bulkAssignmentDialog.context";
import { useKorrekturStepAssignmentOperations } from "../contexts/korrekturStepAssignment.context";

/**
 * GroupExamsTab component for displaying user exams in the group and assinging them to the specific correctors
 */
export function GroupExamsTab() {
	const { klausuren } = useKorrekturStepAssignmentOperations();

	if (klausuren.length === 0) {
		return (
			<Card>
				<CardHeader>
					<CardTitle className="flex items-center gap-2">
						<FileText className="h-5 w-5" />
						Klausuren (0)
					</CardTitle>
				</CardHeader>
				<CardContent>
					<div className="text-center py-8 text-muted-foreground">
						<FileText className="h-12 w-12 mx-auto mb-4 opacity-50" />
						<p className="mb-2">Noch keine Klausuren in dieser Gruppe.</p>
						<p className="text-sm">
							Klausuren werden automatisch sichtbar, sobald Studentenklausuren
							für diese Gruppe hochgeladen werden.
						</p>
					</div>
				</CardContent>
			</Card>
		);
	}

	return (
		<div className="space-y-4">
			<BulkAssignmentDialogProvider>
				<KorrekturStatusTable />
			</BulkAssignmentDialogProvider>
		</div>
	);
}
